import Vivus from 'vivus';

window.onload = function () {
  const fvSpMainWrap = document.getElementsByClassName('c-fv__img--sp-main');
  const paths = document.querySelectorAll('#fv-main-text path');
  paths.forEach(function (path) {
    path.style.opacity = 0;
  });

  if (fvSpMainWrap.length > 0) {
    setTimeout(function () {
      paths.forEach(function (path) {
        path.style.opacity = 1;
      });

      var logo = new Vivus('fv-main-text', {
        type: 'sync',
        duration: 80,
        animTimingFunction: Vivus.EASE_OUT,
        start: 'autostart'
      }, function (obj) {
        const fvSpMain = document.getElementsByClassName('c-fv__img--sp-main')[0];
        if (fvSpMain) {
          fvSpMain.style.opacity = 1;
        }
      });
    }, 300);
  }
};